/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface UserUserStatusTypesGet$Plain$Params {
}

export function userUserStatusTypesGet$Plain(http: HttpClient, rootUrl: string, params?: UserUserStatusTypesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, userUserStatusTypesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

userUserStatusTypesGet$Plain.PATH = '/User/UserStatusTypes';
